import React, { useEffect, useState } from 'react'

import { useCurrentSelectableUser } from 'modules/auth/hooks/useCurrentSelectableUser'
import { AuthPageTemplate } from 'modules/auth/templates'
import { Navigate } from 'react-router-dom'
import cyanOrangeBg from 'shared/assets/wallpapers/cyan-orange.webp'
import { CustomEvents, CustomEventsMap } from 'shared/constants/customEvents'
import { listenCustomEvent } from 'shared/utils/customEvents'

import { LoginMode, LoginModeType } from '../../LoginPage.types'
import { DeactivateTwoFa, OtpView } from '../../components'
import styles from './SelectedUserView.module.scss'
import { SelectedUserLoginForm } from './components'

export const SelectedUserView = () => {
  const [loginMode, setLoginMode] = useState<LoginModeType>(LoginMode.Regular)
  const [mobileApprovalSessionId, setMobileApprovalSessionId] =
    useState<
      CustomEventsMap[CustomEvents.AUTH_LOGIN_REQUIRES_OTP]['mobileApprovalSessionId']
    >(null)

  const selectedUser = useCurrentSelectableUser()

  useEffect(() => {
    const unsubscribe = listenCustomEvent(
      CustomEvents.AUTH_LOGIN_REQUIRES_OTP,
      event => {
        setLoginMode(LoginMode.Otp)
        setMobileApprovalSessionId(event.mobileApprovalSessionId)
      }
    )

    return unsubscribe
  }, [])

  if (!selectedUser) {
    return <Navigate to='/login' replace />
  }

  const getContentView = () => {
    switch (loginMode) {
      case LoginMode.Otp:
        return (
          <OtpView
            mobileApprovalSessionId={mobileApprovalSessionId}
            setLoginMode={setLoginMode}
          />
        )
      case LoginMode.DeactivateOtp:
        return <DeactivateTwoFa />
      case LoginMode.Regular:
      default:
        return <SelectedUserLoginForm user={selectedUser} />
    }
  }

  return (
    <AuthPageTemplate
      backgroundImageUrl={cyanOrangeBg}
      backButton
      className={styles.selectedUserView}
    >
      <div className={styles.content}>{getContentView()}</div>
    </AuthPageTemplate>
  )
}
